<template>
    <navbar />
    <!-- partial -->
    <div class="container-fluid page-body-wrapper">
      <sidebar />
      <div class="main-panel">
        <div class="content-wrapper">
          <div class="row">
            <div class="col-lg-12 px-0">
              <div class="card">
                <div class="card-body">
                  <div class="row col-md-9 mb-4">
                      <div class="d-flex flex-wrap gap-3">
                          <button class="btn text-white py-2 px-4" style="background-color: #007bff; border-radius: 6%;" data-bs-toggle="modal" data-bs-target="#addModal">Add New Block</button>
                      </div>
                  </div>
                  <div class="row mb-3 align-items-center">
                    <div class="col-md-2">
                      <select class="form-control form-control-sm" v-model="searchForm.wardId" @change="selectRoad($event)">
                          <option value="" disabled selected>-- Select Ward--</option>
                          <option v-for="(data, index) in wardList" :key="index" :value="data.id">
                              {{ data.name }}
                          </option>                      
                      </select>                    
                    </div>
                    <div class="col-md-2">
                      <select class="form-control form-control-sm" v-model="searchForm.roadId"  @change="selectBlock($event)" :disabled="disableOne">
                        <option value="" disabled selected>-- Select Road --</option>
                        <option v-for="(data, index) in roadList" :key="index" :value="data.id" >
                            {{ data.name }}
                        </option>                      
                      </select>                        
                    </div>
                    <div class="col-md-2">
                      <select class="form-control form-control-sm" v-model="searchForm.BlockName" :disabled="disableTwo">
                        <option value="" disabled selected>-- Select Block --</option>
                        <option v-for="(data, index) in blockListData" :key="index" :value="data.name" >
                            {{ data.name }}
                        </option>                      
                      </select>                     
                    </div>
                    <div class="col-md-2">
                        <select class="form-control form-control-sm" v-model="searchForm.BlockStatus">
                            <option value="" disabled>-- Select --</option>
                            <option value="active">Active</option>
                            <option value="inactive">InActive</option>
                        </select>
                    </div>
                    <div class="col-md-1">
                      <button class="btn btn-success btn-block btn-sm text-white" style="border-radius: 6%;" @click="searchBlock()">Search</button>
                    </div>
                    <div class="col-md-1">
                      <button class="btn btn-danger btn-block btn-sm text-white" style="border-radius: 6%;" @click="resetBlock()">Reset</button>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table class="table table-striped table-borderless">
                      <thead style="border-top: 1px solid grey; border-bottom: 1px solid grey;">
                        <tr>
                          <th>SL No.</th>
                          <th>Ward</th>
                          <th>Road</th>
                          <th>Block</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody v-if="blockList != null">
                        <tr v-for="(data, index) in blockList" :key="index">
                          <td>{{(pagination.current_page*10)-10 + index+1}}</td>
                          <td class="font-weight-bold">{{ data.WardName }}</td>
                          <td class="font-weight-bold">{{ data.RoadName }}</td>
                          <td class="font-weight-bold">{{ data.BlockName }}</td>
                          <td>
                            <span class="badge badge-success" v-if="data.BlockStatus == 'active'">Active</span>
                            <span class="badge badge-danger"  v-else>InActive</span>
                          </td>
                          <td>
                              <div class="dropdown">
                                <a href="#" class="text-dark" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i class="fa-solid fa-gear fa-lg" style="color: #63452c;"></i>                           
                                </a>
                                <ul class="dropdown-menu">
                                    <li><button class="dropdown-item" data-bs-toggle="modal" :data-bs-target="'#edit-road'+index" @click="editBlock(data.BlockPrimaryId)">Edit</button></li>
                                </ul>
                              </div>
                               <!-- Edit Citizen modal -->
                              <div class="modal fade" :id="'edit-road'+index" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                  <div class="modal-dialog custom-md-model"> <!-- Apply the custom class here -->
                                      <div class="modal-content">
                                      
                                      <!-- Modal Header -->
                                      <div class="modal-header">
                                          <h5 class="modal-title" id="exampleModalLabel">Edit Block</h5>
                                          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                      </div>
                                      <!-- Modal Body -->
                                      <div class="modal-body px-4">
                                        <div class="row">
                                            <div class="col-md-3 form-group mb-3">
                                                <label class="form-label fw-bold">Ward:</label>
                                                <select class="form-control form-control-sm" v-model="editForm.wardId" :disabled="true">
                                                    <option value="" disabled selected>-- Select --</option>
                                                    <option v-for="(data, index) in wardList" :key="index" :value="data.id">
                                                        {{ data.name }}
                                                    </option>                      
                                                </select>
                                            </div>
                                            <div class="col-md-3 form-group mb-3">
                                                <label class="form-label fw-bold">Road:</label>
                                                <select class="form-control form-control-sm" v-model="editForm.roadId">
                                                  <option value="" disabled selected>-- Select --</option>
                                                  <option v-for="(data, index) in roadList" :key="index" :value="data.id" >
                                                      {{ data.name }}
                                                  </option>                      
                                                </select>                                             </div>
                                            <div class="col-md-3 form-group mb-3">
                                                <label class="form-label fw-bold">Block:</label>
                                                <input type="text" class="form-control form-control-sm" v-model="editForm.name"> 
                                            </div>
                                            <div class="col-md-3 form-group mb-3">
                                                <label class="form-label fw-bold">Status:</label>
                                                <select class="form-control form-control-sm" v-model="editForm.status">
                                                    <option value="active">Active</option>
                                                    <option value="inactive">Inactive</option>
                                                </select>
                                            </div>
                                        </div>
                                      </div>
                                      <!-- Modal Footer -->
                                      <div class="modal-footer">
                                        <button type="button" class="btn btn-danger text-white py-2" data-bs-dismiss="modal" style="border-radius: 6%;">Cancel</button>
                                        <button type="submit" class="btn btn-success text-white py-2" style="border-radius: 6%;" @click="updateBlock(data.BlockPrimaryId)">Update</button>
                                      </div>
                                      </div>
                                  </div>
                              </div>
                          </td>
  
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="13" style="text-align: center; font-size: 18px;color: #de0723;">No Data Found !</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="p-2" v-if="this.searchPagination == false">
                        <pagination v-if="pagination.last_page > 1" 
                        :pagination="pagination" 
                        :offset="10" 
                        @paginate="getBlock()">
                        </pagination>
                    </div>
                    <div v-else>
                        <pagination v-if="pagination.last_page > 1" 
                        :pagination="pagination" 
                        :offset="10" 
                        @paginate="searchBlock()">
                        </pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="footer">
          <div class="d-sm-flex justify-content-center justify-content-sm-between">
              <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2023. Premium <a href="" target="_blank"></a> All rights reserved.</span>
              <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center"></span>
          </div>
        </footer>
      </div>
      <!-- Add New Ward modal -->
      <div class="modal fade" id="addModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog custom-md-model">
            <form class="form" @submit.prevent="addBlock()">
              <div class="modal-content">
              
              <!-- Modal Header -->
              <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">New Block</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              
              <!-- Modal Body -->
              <div class="modal-body px-4">
                  <div class="row">
                    <div class="col-md-3 form-group mb-3">
                      <label class="form-label fw-bold">Ward:</label>
                      <select class="form-control form-control-sm" v-model="addForm.wardId" @change="selectRoad($event)">
                        <option value="" disabled selected>-- Select --</option>
                        <option v-for="(data, index) in wardList" :key="index" :value="data.id">
                            {{ data.name }}
                        </option>                      
                      </select>
                    </div>
                    <div class="col-md-3 form-group mb-3">
                      <label class="form-label fw-bold">Road:</label>
                      <select class="form-control form-control-sm" v-model="addForm.roadId">
                        <option value="" disabled selected>-- Select --</option>
                        <option v-for="(data, index) in roadList" :key="index" :value="data.id" >
                            {{ data.name }}
                        </option>                      
                      </select>                    
                    </div>
                    <div class="col-md-3 form-group mb-3">
                      <label class="form-label fw-bold">Block:</label>
                      <input type="text" class="form-control form-control-sm" v-model="addForm.name"> 
                    </div>
                    <div class="col-md-3 form-group mb-3">
                      <label class="form-label fw-bold">Status:</label>
                      <select class="form-control form-control-sm" v-model="addForm.status">
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                  </div>
              </div>
              <!-- Modal Footer -->
              <div class="modal-footer">
                <button type="button" class="btn btn-danger text-white py-2" data-bs-dismiss="modal" style="border-radius: 6%;">Cancel</button>
                <button type="submit" class="btn btn-success text-white py-2" style="border-radius: 6%;">Save</button>
              </div>
              
              </div>
            </form>
          </div>
      </div>
      <!-- main-panel ends -->
    </div>
  </template>
  <script>
    import Navbar   from '../layouts/navbar.vue';
    import Sidebar  from '../layouts/sidebar.vue';
    import Api      from '../util/Api';
    import Chokidar from '../util/Chokidar';
    import Pagination   from '../util/Pagination.vue'
  
    export default {
      components: {
        navbar: Navbar,
        sidebar: Sidebar,
        pagination: Pagination
      },
      data() {
        return {
  
          isLoading : false,
  
          addForm:{
            wardId : '',
            roadId : '',
            name   : '',
            status : ''
          },
          editForm:{
            wardId : '',
            roadId : '',
            name   : '',
            status : ''
          },
  
          wardList  : [{}],
          roadList  : [{}],
          blockList : [{}],

          blockListData : [{}],

          disableOne    : true,
          disableTwo    : true,

          pagination: {
            current_page: 1,
          },
  
          searchPagination : false,
  
          searchForm:{
            wardId       : '',
            roadId       : '',
            BlockName    : '',
            BlockStatus  : ''
          }
  
        }
      },
  
      methods:{
        getAllWards(){
            Api().get('/ward-list')
            .catch((error) => {
                if (error.response.status == 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('guard');
                this.$swal({
                    icon: 'error',
                    title: 'Session Expired, please login!',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 4000
                });
                this.$router.push('/login');
                } 
            }).then(response =>{
                this.wardList    = response.data.data;
            });
        },
        selectRoad(event){
            console.log('select road',event.target.value);
            Api().get('/road-list/'+event.target.value)
            .catch((error) => {
                if (error.response.status == 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('guard');
                this.$swal({
                    icon: 'error',
                    title: 'Session Expired, please login!',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 4000
                });
                this.$router.push('/login');
                } 
            }).then(response =>{
                this.roadList    = response.data.data;
            });
            this.disableOne = false;
        },
        selectBlock(event){
            console.log('select block',event.target.value);
            Api().get('/block-list/'+event.target.value)
            .catch((error) => {
                if (error.response.status == 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('guard');
                this.$swal({
                    icon: 'error',
                    title: 'Session Expired, please login!',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 4000
                });
                this.$router.push('/login');
                } 
            }).then(response =>{
                this.blockListData    = response.data.data;
            });
            this.disableTwo = false;
        },
        getBlock(){
          this.searchPagination = false;
          Api().get('/get-block-data/?page='+this.pagination.current_page)
          .catch((error) => {
            if (error.response.status == 401) {
              localStorage.removeItem('token');
              localStorage.removeItem('guard');
              this.$swal({
                icon: 'error',
                title: 'Session Expired, please login!',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 4000
              });
              this.$router.push('/login');
            } 
          }).then(response =>{
            this.blockList    = response.data.data;
            this.pagination   = response.data.meta;
          });
        },
  
        addBlock()
        {
          Api().post('/add-block',this.addForm)
            .catch((error) => {
              if (error.response.status == 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('guard');
                this.$swal({
                  icon: 'error',
                  title: 'Session Expired, please login!',
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 4000
                });
                this.$router.push('/login');
              } 
            }).then(response =>{
              if(response.data['success'] == true)
              {
                this.getBlock();
                $('#addModal').modal('hide');
                this.$swal({
                    icon: 'success',
                    title: ' '+response.data['message'],
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 4000
                });
              }
            });
        },
  
        editBlock(id)
        {
              Api().get('/edit-block/'+id)
              .catch((error) => {
                          if (error.response.status == 401) {
                              localStorage.removeItem('token');
                              localStorage.removeItem('guard');
                              this.$swal({
                              icon: 'error',
                              title: 'Session Expired please login!',
                              toast: true,
                              position: 'top-end',
                              showConfirmButton: false,
                              timer: 4000
                              });
                              this.$router.push('/admin/login');
                          } 
                  }).then((response) => {
                    Api().get('/road-list/'+response.data.wardId)
                    .then(response =>{
                        this.roadList    = response.data.data;
                    });
                    this.editForm ={
                        wardId : response.data.wardId,
                        roadId : response.data.roadId,
                        name   : response.data.BlockName,
                        status : response.data.BlockStatus
                    }
             });
        },
  
        updateBlock(id,index)
        {
            Api().post('/update-block/'+id,this.editForm)
            .catch((error) => {
              if (error.response.status == 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('guard');
                this.$swal({
                  icon: 'error',
                  title: 'Session Expired, please login!',
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 4000
                });
                this.$router.push('/login');
              } 
            }).then(response =>{
              if(response.data['success'] == true)
              {
                this.getBlock();
               
                $('#edit-road'+index).modal('hide');
                this.$swal({
                    icon: 'success',
                    title: ' '+response.data['message'],
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 4000
                });
              }
            });
        },

        searchBlock()
        {
            this.searchPagination = true;
            Api().post('/search-block?page='+this.pagination.current_page,this.searchForm)
            .catch((error) => {
              if (error.response.status == 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('guard');
                this.$swal({
                  icon: 'error',
                  title: 'Session Expired, please login!',
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 4000
                });
                this.$router.push('/login');
              } 
            }).then(response =>{
              console.log(response)
                this.isLoading = false;
                this.blockList   = response.data.data;
                this.pagination  = response.data.meta;
            });
        },
  
        resetBlock(){
          this.searchForm={
            wardId       : '',
            roadId       : '',
            BlockName    : '',
            BlockStatus  : ''
          },
          this.getBlock();
          this.disableOne = true;
          this.disableTwo = true;
        }
      },
      created()
      {
        if(Chokidar() != 'user'){
          this.$router.push('/login');
        }else{
          this.getBlock();
          this.getAllWards();
        }
      }
    }
  </script>